import React, { FunctionComponent } from 'react';
import { ArticleType } from '../../../domain/articleType';
import RelatedArticles, { RelatedArticlesSkeleton } from '../../components/related-articles/RelatedArticles';
import { mapArticlesNodes } from '../../graphql/mappers/articleMappers';
import { RELATED_NEWS_BY_LOCALITY_QUERY } from '../../graphql/queries/news';
import useQuery from '../../hooks/useQuery/useQuery';

export interface ListRelatedNewsByLocalityProps {
  title: string,
  skipId: string,
  locality: string,
  count?: number,
}

const ListRelatedNewsByLocality: FunctionComponent<ListRelatedNewsByLocalityProps> = ({
  title,
  skipId,
  locality,
  count = 4,
}) => {
  const variables = {
    skipId,
    locality,
    first: count,
  };

  const { error, data } = useQuery({
    query: RELATED_NEWS_BY_LOCALITY_QUERY,
    variables,
  });

  if (!data && !error) {
    return (
      <RelatedArticlesSkeleton totalItems={count} />
    );
  }

  return (!error && data.news.length > 0)
    ? (
      <RelatedArticles
        title={title}
        items={mapArticlesNodes(data.news, ArticleType.NEWS)}
      />
    ) : null;
};

export default ListRelatedNewsByLocality;
